import { render, staticRenderFns } from "./InternationalAntiAging.vue?vue&type=template&id=9f00fc10&scoped=true&"
import script from "./InternationalAntiAging.vue?vue&type=script&lang=js&"
export * from "./InternationalAntiAging.vue?vue&type=script&lang=js&"
import style0 from "./InternationalAntiAging.vue?vue&type=style&index=0&id=9f00fc10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f00fc10",
  null
  
)

export default component.exports